export default __webpack_public_path__ + "static/media/Path 5267.d6945a29.svg";